import { render, staticRenderFns } from "./SecondComment.vue?vue&type=template&id=3faf013e&scoped=true&"
import script from "./SecondComment.vue?vue&type=script&lang=js&"
export * from "./SecondComment.vue?vue&type=script&lang=js&"
import style0 from "./SecondComment.vue?vue&type=style&index=0&id=3faf013e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf013e",
  null
  
)

export default component.exports